import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import BaseDialog from 'shared/components/Dialogs/BaseDialog/BaseDialog';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import _ from 'lodash';
import CircularProgress from 'material-ui/CircularProgress';
import { clearSaveError } from 'crazyEditor/redux/modules/editor/editor';
import { KEYS } from 'crazyEditor/core/constants/editorConstants';
import * as Colors from 'material-ui/styles/colors';
import {getListingData} from 'MyAccount/Listings/listingsHelper';
import updateQuery from 'shared/helpers/updateQuery';
import { TYPES, INPUT_DIALOGS } from 'crazyEditor/core/constants/panelConstants';
import {getListingById} from 'MyAccount/Listings/listingsHelper';
const INVALID_LISTING_ERROR_TEXT = 'It doesn\'t look like a listing, typo maybe?';
import {isDraft} from 'crazyEditor/redux/modules/element/elementSelectors';
import {createDraftItemId} from 'MyAccount/Listings/listingsHelper';

@connect(
  state => {
    const {itemId} = state.routing.location.query;
    return {
      itemId: itemId,
      listingData: itemId && getListingById(itemId),
      draft: isDraft(state),
    };
  }, {closeLazyPanel, clearSaveError}
)
export default class ItemIdDialog extends Component {
  constructor(props) {
    super(props);
    this.state = this.getStateFromProps(props);
  }

  componentDidMount() {
    window.setTimeout(() => {
      const {open} = this.props;
      const {itemId} = this.refs;
      if (open) {
        itemId.focus();
      }
    }, 450);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState(this.getStateFromProps(nextProps));
    }
  }

  componentDidUpdate(prevProps) {
    const {open} = this.props;
    window.setTimeout(() => {
      const {itemId} = this.refs;
      if (!prevProps.open && open) {
        itemId.focus();
      }
    }, 450);

  }

  getStateFromProps(props) {
    const {draft, listingData} = props;
    let {itemId} = props;
    itemId = draft ? '' : (itemId || '');
    return {
      itemId,
      errorText: !_.isEmpty(itemId) && _.isEmpty(listingData) ? INVALID_LISTING_ERROR_TEXT : null,
    };
  }

  handleLoadListingData = () => {
    const {itemId} = this.state;
    if (this.inputValid()) {
      this.setState({loading: true});
      getListingData(itemId)
        .then((response) => {
          if (response.success) {
            this.closeDialog();
            updateQuery({itemId}, true);
          } else {
            this.setState({errorText: INVALID_LISTING_ERROR_TEXT});
          }
        }, () => {
          this.setState({errorText: 'Unknown error, please try again'});
        })
        .always(() => {
          this.setState({loading: false});
        });
    }
  };

  closeDialog = () => {
    const {closeLazyPanel} = this.props;
    closeLazyPanel(INPUT_DIALOGS.ITEM_ID);
  };

  handleClose = () => {
    if (this.hasErrors()) {
      updateQuery({itemId: createDraftItemId()});
    }
  };

  hasErrors() {
    const {errorText} = this.state;
    return !_.isEmpty(errorText);
  }

  handleChange = (e, itemId) => {
    const {errorText} = this.state;
    if (errorText) {
      this.setState({errorText: null});
    }
    this.setState({itemId});
  };

  handleKeyDown = (event) => {
    if (event.keyCode === KEYS.ENTER) {
      this.handleLoadListingData();
    }
  };

  inputValid() {
    const {itemId} = this.state;
    return !_.isEmpty(itemId);
  }

  render() {
    const {itemId, errorText, loading} = this.state;
    const actions = [
      <FlatButton
        disabled={!this.inputValid()}
        hoverColor={loading ? 'none' : undefined}
        style={{width: 275}}
        primary
        onClick={this.handleLoadListingData}
        icon={loading ? <CircularProgress thickness={2} size={24} style={{transform: 'translate3d(2px, 5px, 0px)', marginLeft: -12, height: 36, width: 36}}/> : undefined}
        label={loading ? 'loading listing...' : 'select a theme for this listing'}
      />
    ];
    return (
      <BaseDialog
        actions={actions}
        title="Which listing would you like to design?"
        onClose = {this.handleClose}
        {...this.props}
      >
        <div style={{color: Colors.grey700}}>
          All our themes will be populated automatically with your listing's data
        </div>
        <TextField
          ref="itemId"
          value={itemId}
          style={{width: '100%'}}
          floatingLabelText="eBay Item ID"
          hintText="Paste your eBay item ID"
          onChange={this.handleChange}
          errorText={errorText}
          errorStyle = {{float: 'left'}}
          onKeyDown = {this.handleKeyDown}
        />
      </BaseDialog>
    );
  }
}